import React from 'react'
import maldives from './images/maldives.jpg'
export default function () {
  return (
    <div>
        <section id="tour-events-1" className=" my-5 container mt-5 mb-5 ">
  <div id="section-title" className="d-md-flex justify-content-md-between ">
    <h2 className="mt-5 mb-5">Tour Events for You</h2>
    <div>
      <input className="btn text-success fs-3" type="button" defaultValue="←" />
      <input
        className="btn text-success fs-3 "
        type="button"
        defaultValue="→"
      />
    </div>
  </div>
  <div id="tour-events1-a" className="row ">
    <div className="col-3 d-flex flex-column  gap-4  ">
      <div
        id="india"
        className="d-flex flex-column justify-content-between p-1 pointer"
      >
        <span className="badge rounded-pill text-bg-light  w-25 ">
          <i className="fa-solid fa-star text-warning ipads-disable" />
          4.6
        </span>
        <div className="text-light ">
          <h3 className="event1-overlays  border-bottom border-light">
            Goa,India
          </h3>
          <span>sea beach</span>
        </div>
      </div>
      <div
        id="mexico"
        className="d-flex flex-column justify-content-between p-1 pointer"
      >
        <span className="badge rounded-pill text-bg-light  w-25">
          <i className="fa-solid fa-star text-warning ipads-disable" />
          4.6
        </span>
        <div className="text-light ">
          <h3 className="event1-overlays  border-bottom border-light">
            Mexico,sea beach
          </h3>
          <span>sea beach</span>
        </div>
      </div>
    </div>
    <div
      className="col-4 d-flex flex-column justify-content-between pointer "
      id="maldives"
    >
      <span className="badge rounded-pill text-bg-light mt-3 w-25">
        <i className="fa-solid fa-star text-warning ipads-disable" />
        4.6
      </span>
      <div className="text-light  ">
        <h3 className="event1-overlays  border-bottom border-light">
          Kudadoo,Maldives
        </h3>
        <span>sea beach</span>
      </div>
    </div>
    <div className="col-5 d-flex flex-column gap-3  ">
      <div
        id="indonesia"
        className="d-flex flex-column justify-content-between  p-1 pointer"
      >
        <span className="badge rounded-pill text-bg-light  w-25">
          <i className="fa-solid fa-star text-warning ipads-disable" />
          4.6
        </span>
        <div className="text-light ">
          <h3 className="event1-overlays  border-bottom border-light">
            Bali,Indonesia
          </h3>
          <span>sea beach</span>
        </div>
      </div>
      <div className=" d-flex gap-4  ">
        <div
          id="nepal"
          className="d-flex flex-column justify-content-between p-2 pointer"
        >
          <span className="badge rounded-pill text-bg-light  w-25 p-1">
            {" "}
            <i className="fa-solid fa-star text-warning ipads-disable" />
            4.6{" "}
          </span>
          <div className="text-light ">
            <h3 className="event1-overlays  border-bottom border-light">
              Nepal
            </h3>
            <span>sea beach</span>
          </div>
        </div>
        <div
          id="thailand"
          className="d-flex flex-column justify-content-between p-2 pointer"
        >
          <span className="badge rounded-pill text-bg-light  w-25">
            <i className="fa-solid fa-star text-warning ipads-disable" />
            4.6
          </span>
          <div className="text-light ">
            <h3 className="event1-overlays  border-bottom border-light">
              Thailand
            </h3>
            <span>sea beach</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="tour-events1-b" className="container row">
    <div
      id="carouselExampleSlidesOnly"
      className="carousel slide col-12"
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src={maldives} className="d-block w-100" alt="" />
          <div className="carousel-caption   d-flex flex-column justify-content-between">
            <div className="text-light ">
              <h3 className="event1-overlays  border-bottom border-light">
                Kudadoo,Maldives
              </h3>
              <span>sea beach</span>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <img src={maldives} className="d-block w-100" alt="..." />
          <div className="carousel-caption   d-flex flex-column justify-content-between">
            <div className="text-light ">
              <h3 className="event1-overlays  border-bottom border-light">
                Kudadoo,Maldives
              </h3>
              <span>sea beach</span>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <img src={maldives} className="d-block w-100" alt="..." />
          <div className="carousel-caption   d-flex flex-column justify-content-between">
            <div className="text-light ">
              <h3 className="event1-overlays  border-bottom border-light">
                Kudadoo,Maldives
              </h3>
              <span>sea beach</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* </div> */}
  {/* </div>   */}
</section>

    </div>
  )
}
